const deleteCard = cardRef => {
  return cardRef
    .delete()
}

export default deleteCard
